export const DATA_SOURCE = (process.env.DATA_SOURCE as "static" | "remote") || "static";
export const isRemoteDataSource = () => DATA_SOURCE === "remote";
